import { useRef, useState } from 'react'
import { prepararImagem, ERRO_IMAGEM } from '../lib/imagem'

type Props = {
  imagem: string | null
  aoMudar: (dataUrl: string | null) => void
  rotuloVazio: string
  tamanho?: 'grande' | 'pequeno'
  testId: string
}

// Spec 2026-10-06: o mesmo quadro no Meu perfil e na fornecedora. Imagem
// INTEIRA sobre fundo branco (logo retangular nao e cortado).
export default function QuadroDaImagem({ imagem, aoMudar, rotuloVazio, tamanho = 'grande', testId }: Props) {
  const entrada = useRef<HTMLInputElement>(null)
  const [erro, setErro] = useState<string | null>(null)
  const [lendo, setLendo] = useState(false)
  const lado = tamanho === 'grande' ? 'w-24 h-24' : 'w-14 h-14'

  async function aoEscolher(arquivo: File | undefined) {
    if (!arquivo) return
    setErro(null)
    setLendo(true)
    try { aoMudar(await prepararImagem(arquivo)) } catch { setErro(ERRO_IMAGEM) } finally {
      setLendo(false)
      if (entrada.current) entrada.current.value = ''
    }
  }

  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <div className={`${lado} shrink-0 rounded-xl border border-slate-200 bg-white flex items-center justify-center overflow-hidden`}>
        {imagem
          ? <img src={imagem} alt="Imagem escolhida" className="w-full h-full object-contain" />
          : <span className="text-2xl text-slate-300" aria-hidden="true">🖼</span>}
      </div>
      <div className="flex flex-wrap gap-2">
        <input ref={entrada} type="file" accept="image/*" className="hidden" aria-label={rotuloVazio}
          onChange={(e) => void aoEscolher(e.target.files?.[0])} />
        <button type="button" disabled={lendo} onClick={() => entrada.current?.click()}
          className="text-sm border border-teal-700 text-teal-800 rounded-lg px-3 py-1.5">
          {lendo ? 'Preparando…' : imagem ? 'Trocar' : rotuloVazio}
        </button>
        {imagem && (
          <button type="button" onClick={() => aoMudar(null)}
            className="text-sm border border-slate-300 text-slate-600 rounded-lg px-3 py-1.5">Remover</button>
        )}
        {erro && <p role="alert" className="w-full text-xs text-red-700">{erro}</p>}
      </div>
    </div>
  )
}
